import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const purgeIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M15 0C16.627 19.17 0 25.77 0 42.656 0 54.126 8.184 63.915 24 64c15.816.085 24-11.77 24-23.883 0-11.042-5.499-21.456-15.872-27.93 2.464 6.952-.816 13.301-4.003 15.488C28.312 18.776 25.125 5.57 15 0Zm12.563 34.667c10.013 10.637 3.864 24-4.179 24-4.893 0-7.41-3.374-7.384-6.872.05-6.488 7.299-6.494 11.563-17.128Z"/></svg>`
);
